import { create, StoreApi, UseBoundStore } from 'zustand';

import { DatasetState, RobotInfo } from '@mygpt/app/apis';
import { DatasetsInfoWithProgress } from '@mygpt/app/datasets/services';
import { BotId } from '@mygpt/types';

interface BotStore {
  botId: BotId;
  robotInfo?: RobotInfo;
}

export const botStore = create<BotStore>(() => ({
  botId: '',
  robotInfo: undefined,
}));

const botWeakMap = new WeakMap<UseBoundStore<StoreApi<BotStore>>, string>();
export const Bot = {
  setDefaultBotId: (id?: BotId) => {
    if (!id) botWeakMap.delete(botStore);
    else botWeakMap.set(botStore, id);
  },
  getDefaultBotId: () => {
    return botWeakMap.get(botStore);
  },
  delDefaultBotId: () => {
    botWeakMap.delete(botStore);
  },
};

// bot信息，包括bot关联的dataset
interface BotStoreStatus {
  robotInfo: RobotInfo | undefined;
  setRobotInfo: (robotInfo: RobotInfo) => void;
  linkedDataset: DatasetsInfoWithProgress[];
  setLinkedDataset: (linkedDataset: DatasetsInfoWithProgress[]) => void;
  setDatasetStatus: (datasetProgress: Record<string, DatasetState>) => void;
}

export const useBotStore = create<BotStoreStatus>((set, get) => ({
  robotInfo: undefined,
  setRobotInfo: (robotInfo) => set({ robotInfo }),
  linkedDataset: [],
  setLinkedDataset: (linkedDataset) => set({ linkedDataset }),
  setDatasetStatus: (datasetProgress: Record<string, DatasetState>) => {
    const { linkedDataset } = get();
    const newLinkedDataset = linkedDataset.map((dataset) => {
      const progress = datasetProgress[dataset.id];
      if (!progress) return dataset;

      const total = progress.datasource_statistical_map.total;
      return {
        ...dataset,
        total_resources: total.total,
        status: {
          learned_count: total.complete,
          learning_count: total.process,
          pending_count: total.ready,
          failed_count: total.fail + total.exceeded,
        },
      };
    });
    set({ linkedDataset: newLinkedDataset });
  },
}));
